import practiceData from "./practice.json";

export type PracticeData = typeof practiceData;

export const practice: PracticeData = practiceData;

export const formatOpeningHoursSpecification = () =>
  practice.hours.map((slot) => ({
    "@type": "OpeningHoursSpecification" as const,
    dayOfWeek: slot.days.length === 1 ? slot.days[0] : slot.days,
    opens: slot.opens,
    closes: slot.closes,
  }));
